import {
  DSBadge,
  DSLinkButton,
} from "@components/design-system/molecules";
import type { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { faCheck, faUndo } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

interface MilestoneRowProps {
  icon: IconDefinition;
  label: string;
  completed: boolean;
  current: boolean;
  onAction?: () => void;
}

export default function MilestoneRow({
  icon,
  label,
  completed,
  current,
  onAction,
}: MilestoneRowProps) {
  return (
    <div
      className="flex items-center gap-sm py-xs"
      data-testid={`milestone-row-${label}`}
    >
      <div
        className={`shrink-0 w-5 h-5 rounded-full flex items-center justify-center text-[10px] ${
          completed
            ? "bg-success text-white"
            : current
              ? "bg-brand text-white"
              : "bg-tertiary text-placeholder"
        }`}
      >
        <FontAwesomeIcon icon={completed ? faCheck : icon} />
      </div>
      <span
        className={`text-sm flex-1 ${
          completed
            ? "text-success line-through decoration-success/40"
            : current
              ? "text-brand font-medium"
              : "text-secondary"
        }`}
      >
        {label}
      </span>
      {completed && (
        <>
          <DSBadge
            variant="green"
            size="sm"
            dataTestId={`done-${label}`}
          >
            Done
          </DSBadge>
          {onAction && (
            <DSLinkButton
              dataTestId={`action-${label}`}
              onClick={onAction}
              icon={faUndo}
            >
              Show me again
            </DSLinkButton>
          )}
        </>
      )}
      {current && (
        <DSBadge
          variant="brand"
          size="sm"
          dataTestId={`next-${label}`}
        >
          Up next
        </DSBadge>
      )}
    </div>
  );
}
